import {
  accessoriesTypes,
  avatarStyles,
  clothTypes,
  eyebrowTypes,
  eyeTypes,
  facialHairTypes,
  mouthTypes, skinColors,
  topTypes
} from './types';

export const inputTypesMapping = {
  avatarStyle: avatarStyles,
  top: topTypes,
  accessories: accessoriesTypes,
  facialHair: facialHairTypes,
  clothes: clothTypes,
  eyes: eyeTypes,
  eyebrows: eyebrowTypes,
  mouth: mouthTypes,
  skin: skinColors
};
